module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_13_m.7ad0ed0b6c46cb8e2a31162f7ff0dcb4.png";